var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFFFFF","fillRule":"evenodd","d":"M45.347 0H2.653A2.653 2.653 0 0 0 0 2.653v42.694A2.653 2.653 0 0 0 2.653 48h22.99V29.474h-6.275v-7.301h6.24v-5.33c0-6.207 3.781-9.584 9.314-9.584 1.88.006 3.757.112 5.625.32v6.476h-3.823c-3.006 0-3.587 1.423-3.587 3.52v4.631h7.2l-.935 7.268h-6.265V48h12.21A2.653 2.653 0 0 0 48 45.347V2.653A2.653 2.653 0 0 0 45.347 0z"}));
}

Facebook.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Facebook;

Facebook.default = Facebook;
